import type { Workflow } from "ee/constants/WorkflowConstants";

interface Props {
  workflowsList: Workflow[];
}

const WorkflowSearchItem = (props: Props) => {
  // eslint-disable-next-line
  const { workflowsList } = props;
  return null;
};

export default WorkflowSearchItem;
